var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscoverButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 43,
    viewBox: "0 0 52 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9090_42)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 11,
    width: 11,
    height: 32,
    rx: 5.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 17,
    width: 11,
    height: 26,
    rx: 5.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    width: 11,
    height: 43,
    rx: 5.5,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9090_42"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 43,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverButton);
export default __webpack_public_path__ + "static/media/discover-button.3acb06138b114f98db226e2d8374df58.svg";
export { ForwardRef as ReactComponent };